import {field} from "@fedeltapointofsale/data-client";
import {ReportData} from "../../../reports/report.data";

export class SupplierInvoiceReportData extends ReportData<SupplierInvoiceReportData> {
    @field invoiceId: number;
}
